import ActivityIcon from "@/components/common/ActivityIcon";
import Accordion from "@/components/common/accordion/Accordion";
import AccordionItem from "@/components/detail/DetailBooking/DetailBookingSidebar/Accordion";
import { WhatIsIncludedTO } from "@/models/detail";
import { QuillDeltaToHtmlConverter } from "quill-delta-to-html";
import styles from "@/styles/detail/DetailBookingSidebar/ActivityIconBody.module.scss";
import { ActivityReableTO } from "@/models/common/common";
import { MDBCol, MDBContainer, MDBRow } from "mdb-react-ui-kit";
import descriptionStyles from "@/styles/detail/DetailDescription.module.scss";
import AccordionItemActivity from "./AccordionItemActivity";

const ActivityIconBody = ({
    whatIsIncluded,
    whatIsIncludedDelta,
    activities,
}: {
    whatIsIncluded: WhatIsIncludedTO[];
    whatIsIncludedDelta: {
        ops: unknown[];
    }[];
    activities?: ActivityReableTO[];
}) => {
    return (
        <div className={styles.container}>
            <Accordion className="p-0 m-0">
                <AccordionItem
                    title="What is included:"
                    className="border-0 p-0 m-0"
                    showDivider={false}
                >
                    {whatIsIncluded?.map((el, idx) => {
                        return (
                            <Accordion
                                className="p-0 m-0 mb-3"
                                key={el.name || idx}
                            >
                                <AccordionItemActivity
                                    title={el.name}
                                    showDivider={false}
                                    classNameHeader="pb-0"
                                    extraTitle={
                                        <ActivityIcon
                                            alt={el.name}
                                            borderColor={el.color}
                                            src={el.icon}
                                            className="p-2"
                                            isSmall
                                        />
                                    }
                                >
                                    <div
                                        // eslint-disable-next-line react/no-danger
                                        dangerouslySetInnerHTML={{
                                            __html: new QuillDeltaToHtmlConverter(
                                                whatIsIncludedDelta.at(idx)
                                                    ?.ops ?? []
                                            ).convert(),
                                        }}
                                    />
                                </AccordionItemActivity>
                            </Accordion>
                        );
                    })}
                </AccordionItem>
            </Accordion>
            {activities && activities.length > 0 && (
                <div
                    className={descriptionStyles.activitiesContainer}
                    style={{ marginTop: "2rem" }}
                >
                    <h3 className={descriptionStyles.includedActivitiesTitle}>
                        Included activities
                    </h3>
                    <MDBContainer fluid className="p-0">
                        <MDBRow className="p-0">
                            {activities.map(el => (
                                <MDBCol
                                    // eslint-disable-next-line no-underscore-dangle
                                    key={el._id}
                                    size={6}
                                    className="py-2"
                                    center
                                >
                                    <MDBRow
                                        className={
                                            descriptionStyles.containerColSize
                                        }
                                    >
                                        <MDBCol
                                            className={`${descriptionStyles.colSize} px-0`}
                                            size={3}
                                            md={3}
                                            xxl={2}
                                        >
                                            <ActivityIcon
                                                alt={el.name}
                                                borderColor={el.color}
                                                src={el.icon}
                                                className="p-2 p-md-3"
                                            />
                                        </MDBCol>
                                        <MDBCol
                                            className={`px-md-2 ${descriptionStyles.activityName}`}
                                        >
                                            {el.name}
                                        </MDBCol>
                                    </MDBRow>
                                </MDBCol>
                            ))}
                        </MDBRow>
                    </MDBContainer>
                </div>
            )}
        </div>
    );
};

export default ActivityIconBody;
